(function () {
  const SCROLL_SPEED = 1;

  function initAutoScroll(carousel) {
    if (carousel.dataset.autoscrollInit) return;
    carousel.dataset.autoscrollInit = 'true';

    // Desactivar scroll-snap para permitir movimiento continuo
    carousel.style.scrollSnapType = 'none';

    // Duplicar contenido para loop infinito sin saltos
    const items = Array.from(carousel.children);
    if (items.length === 0) return;

    items.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      carousel.appendChild(clone);
    });

    let isPaused = false;
    let scrollPos = 0;
    const halfWidth = carousel.scrollWidth / 2;

    function step() {
      if (!isPaused) {
        scrollPos += SCROLL_SPEED;
        if (scrollPos >= halfWidth) {
          scrollPos = 0;
        }
        carousel.scrollLeft = scrollPos;
      }
      requestAnimationFrame(step);
    }

    carousel.addEventListener('mouseenter', () => { isPaused = true; });
    carousel.addEventListener('mouseleave', () => { isPaused = false; });
    carousel.addEventListener('touchstart', () => { isPaused = true; }, { passive: true });
    carousel.addEventListener('touchend', () => {
      setTimeout(() => { isPaused = false; }, 2000);
    }, { passive: true });

    requestAnimationFrame(step);
  }

  function findAndInitCarousels() {
    // Selector correcto para el tema Horizon
    document.querySelectorAll('slideshow-slides, [ref="scroller"]').forEach(initAutoScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', findAndInitCarousels);
  } else {
    findAndInitCarousels();
  }

  document.addEventListener('shopify:section:load', findAndInitCarousels);
})();
